import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Card, Text, Title } from "@mantine/core";
import { getThree } from "../../requests/wedding";

// Jason's way into the D&D group's wedding puzzle (/wedding/three). The server decides who may
// preview it, so this shows only on his account. It follows the active character picked above.
const PuzzlePreviewCard = ({ activeCharacterId }) => {
  const [puzzle, setPuzzle] = useState(null);

  useEffect(() => {
    let cancelled = false;
    getThree()
      .then((result) => !cancelled && setPuzzle(result))
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [activeCharacterId]);

  if (puzzle?.access !== "preview") return null;

  const names = puzzle.characters?.map((character) => character.name) ?? [];
  return (
    <Card withBorder radius="md" padding="md" m="xs" mt="md">
      <Title order={5}>Wedding puzzle preview</Title>
      <Text size="sm" c="dimmed" mt={4}>
        {puzzle.lines
          ? `See what ${puzzle.character.name}'s player sees after they RSVP.`
          : `Make ${names.slice(0, -1).join(", ")} or ${names.at(
              -1,
            )} your active character to preview their message.`}
      </Text>
      <Button
        component={Link}
        to="/wedding/three"
        variant={puzzle.lines ? "filled" : "light"}
        mt="sm"
      >
        {puzzle.lines
          ? `Open the puzzle as ${puzzle.character.name}`
          : "Open the puzzle"}
      </Button>
    </Card>
  );
};

export default PuzzlePreviewCard;
